import { TextField } from '@mui/material';
import Input from 'react-phone-number-input/input';
import { useRef, useTransition, InputHTMLAttributes } from 'react';

import { PhoneInputProps } from './types';

export const PhoneInput = ({ value, onChange, ...props }: PhoneInputProps) => {
  const [, startTransition] = useTransition();
  const prevValueRef = useRef(value ?? '');

  return (
    <TextField
      {...props}
      value={value}
      slotProps={{
        input: {
          inputComponent: Input as any,
          inputProps: {
            country: 'US',
            onChange: (newValue: string | undefined) => {
              const normalized = newValue ?? '';

              if (normalized === prevValueRef.current) return;
              prevValueRef.current = normalized;

              startTransition(() => {
                onChange?.({
                  target: { value: normalized },
                });
              });
            },
          } as unknown as InputHTMLAttributes<HTMLInputElement>,
        },
      }}
    />
  );
};
